<div class="position-fixed bottom-1 start-1 end-1 z-index-toast">
  @for (toast of toastsService.toasts(); track toast.id) {
    <ngb-toast [class]="toast.class" [autohide]="true" [delay]="5000" (hidden)="toastsService.removeToast(toast.id)">
      {{ toast.text }}
    </ngb-toast>
  }
</div>
